// ====== Slot Types =====
export const SLOT_TYPES = {
  CAM_LIVE: 'cam',
  CAM_PA: 'cam_pa', // PA = Pre-Alarm
  CAM_RECORDED: 'cam_recorded',
  ACTION_PLAN: 'action_plan',
  INFO: 'info',
  INTERPHONE:'info-interphone',
  MAP: 'map',
  CUSTOM_MAP: 'custom_map',
  PLANE: 'plane',
  TAG: 'tag',
  UNITS_MAP: 'units_map',
  TIMELINE: 'timeline',
  GPS: 'gps',
  FRAME: 'frame',
  CHARTS_SDK: 'charts_sdk',
  CHARTS_SDK_DATA: 'charts_sdk_data',
  FR_TRACKING_MAP: 'fr_tracking_map',
  LPR_TRACKING_MAP: 'lpr_tracking_map',
  AR_TABLE_DATA: 'ar_table_data',
  WEATHER: 'weather',
  FACE_DETECTION: 'face_detection',
  WAZE: 'waze',
  CHAT: 'chat',
  LPR_DETECTION: 'lpr_detection',
  DETECTION_EVENT: 'detection_event',
  WEB_UI: 'web_ui',
  PRODUCT_COUNT_IMAGE: 'product_count_image',
  PRODUCT_COUNT_CHART: 'product_count_chart',
  PRODUCT_COUNT_CHART_HISTORY: 'product_count_chart_history',
  FACESTREAM: 'facestream',
  FACESTREAMNTECHLAB: 'facestreamNtechlab',
  HELPDESK: 'helpdesk',
  DOCUMENT_ACTION_PLAN: 'document_action_plan',
  ALARM_BRIDGE_PANEL: 'alarm_bridge',
  FACE_SEARCH: 'face_search',
  RISK_EVALUATION: 'risk_evaluation',
  OPERATIONAL_SECURITY_LIST: 'operational_security_list',
  OPERATIONAL_SECURITY_FORM: 'operational_security_form',
  SIGNIFICANT_EVENT_LIST: 'significant_event_list',
  SIMULACRUM: 'simulacrum',
  OPERATIONAL_PROCEDURE: 'operational_procedure',
  SECURITY_SELF_AUDIT: 'security_self_audit',
  DRAGGABLE_MENU: 'draggable_menu',
  MULTI_CAMERA: 'multi_camera',
  CHARTS_EMBEDDER: 'charts_embedder',
  NEO_DASH: 'neo_dash',
  MASTER_DATA: 'master_data',
  DAMAGES: 'damages',
  CRISIS_FACILITIES: 'crisis_facilities',
  MASTER_DATA_TABLE: 'master_data_table',
  ALLOCATIONS_BY_REGION_TABLE: 'allocations_by_region_table',
  ALLOCATIONS_BY_MUNICIPALITY_TABLE: 'alllocations_by_municipality_table',
  ALLOCATIONS_BY_FACILITIES_TABLE: 'allocations_by_facilities_table',
  EMPLOYEE_INFORMATION_BY_FACILITY_TABLE: 'employee_information_by_facility_table',
  EMERGENCY_CONTACTS: 'emergency_contacts',
  HANWHA_LOGS: 'hanwha_logs',
};

// ====== Sources =====
export const SOURCES = {
  ALARM: 'alarm',
  ALARM_VIEW: 'alarm_view',
  CAMERA: 'camera',
  COMMAND: 'command',
  SUBSYSTEM_TREE: 'subsystem_tree',
  UNIT: 'unit',
  ACTUATOR: 'actuator',
  GENERIC_DEVICE: 'generic_devices',
  SUBSYSTEM_TREE_DO: 'digital_output',
  SUBSYSTEM_TREE_VA: 'virtual_alarm',
  SUBSYSTEM_TREE_SENSOR: 'subsystem_tree_sensor',
  SUBSYSTEM_TREE_DND: 'subsystem_tree_dnd',
  MAIN_SEARCH: 'main_search',
  FACE_SEARCH: 'face_search',
  CRISIS_FORM: 'crisis_form',
};


